module.exports = __webpack_public_path__ + "static/img/pasta.23f2261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pasta.png
// module id = 9Am7
// module chunks = 0